module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_04.a78efa0d.svg";